import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GRAPHQL_RATE_LIMIT_EVENT } from '../../utils/helpers/graphqlRateLimit';
import { ErrorPopup } from '../ErrorPopup';

interface Props {
  initialRateLimit?: boolean;
  initialRateLimitKey?: string;
}

export const GlobalRateLimitPopup = ({
  initialRateLimit = false,
  initialRateLimitKey
}: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const lastShownRateLimitKey = useRef<string | null | undefined>();

  useEffect(() => {
    const handleRateLimit = () => {
      setIsOpen(true);
    };

    window.addEventListener(GRAPHQL_RATE_LIMIT_EVENT, handleRateLimit);

    return () => {
      window.removeEventListener(GRAPHQL_RATE_LIMIT_EVENT, handleRateLimit);
    };
  }, []);

  useEffect(() => {
    if (!initialRateLimit) {
      lastShownRateLimitKey.current = undefined;
      return;
    }

    const rateLimitKey = initialRateLimitKey || 'initial-rate-limit';

    if (lastShownRateLimitKey.current === rateLimitKey) {
      return;
    }

    lastShownRateLimitKey.current = rateLimitKey;
    setIsOpen(true);
  }, [initialRateLimit, initialRateLimitKey]);

  return (
    <ErrorPopup
      isOpen={isOpen}
      title={t('common.too_many_requests.title')}
      message={t('common.too_many_requests.description')}
      onClose={() => setIsOpen(false)}
    />
  );
};
